import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Tag } from "../../definitions/tag";
import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class TagService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		super("mpapi/tags", appConfigService.getConfigValue("API_ENDPOINT"));
	}

	getTags(): Observable<Tag[]> {
		return this.api.get(this.url());
	}

	createTag(request: Tag): Observable<Tag> {
		return this.api.post(this.url(), request);
	}

	updateTag(request: Tag): Observable<Tag> {
		return this.api.put(this.url(`/${request.id}`), request);
	}
}
